export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5549.9b2c47a2.jpg";